import { Injectable } from '@angular/core'
import { AuthService } from '@spartacus/core'
import { Observable } from 'rxjs'
import { CommonService } from '../../services/common.service'
import { ActiveCartFacade } from '@spartacus/cart/base/root'
import { QuoteCheckoutService } from '../../../features/quote/quote-checkout/services/quote-checkout.service'

@Injectable({
  providedIn: 'root',
})
export class AddressService {
  cartId: string
  userType: string
  userAddressListData: any
  userAddressListData$: Observable<any>
  userAddressList: any

  constructor(
    private commonService: CommonService,
    private quoteCheckoutService: QuoteCheckoutService,
    private auth: AuthService,

    private activeCartService: ActiveCartFacade
  ) {
    this.activeCartService.getActiveCartId().subscribe((success) => {
      this.cartId = success
    })
  }

  getUserAddressListDetails(userType) {
    let url
    let urlParam = []
    urlParam = ['users', userType, 'rfqcart', 'addresses']
    url = this.commonService.constructUrl(urlParam)
    return this.commonService.getData(url)
  }
  getUSerAddressForCommision(userType) {
    let url
    let urlParam = ['users', userType, 'vscart', 'getSoldToAddresses']
    url = this.commonService.constructUrl(urlParam)
    return this.commonService.getData(url)
  }
  getShipSoldForCommision(userType) {
    let url
    let urlParam = ['users', userType, 'vscart', this.cartId, 'addresses']
    url = this.commonService.constructUrl(urlParam)
    return this.commonService.getData(url)
  }
  getEndUserAddresses(userType) {
    let url
    let urlParam = ['users', userType, 'vscart', 'endUserAddresses']
    url = this.commonService.constructUrl(urlParam)
    return this.commonService.getData(url)
  }
}
